import React from 'react';

import { ReactComponent as XIcon } from "assets/icons/commons/XIcon.svg";
import type { IActionNotification } from "redux/notifications/reducer";
import { formatDateByLanguage } from 'utils/dateFormatter/dateFormatter';
import { Button } from 'components/commons';
import { useTranslation } from 'react-i18next';

interface IAlertModalContainer {
    dataToShow: IActionNotification | null,
    deleteDataHandler?: (data: IActionNotification) => void,
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    sendDataHandler?: (data: IActionNotification, notification: IActionNotification) => void
}

const AlertModalContainer: React.FC<IAlertModalContainer> = ({ dataToShow, deleteDataHandler, setModalOpen, sendDataHandler }) => {

    const { t } = useTranslation(); 

    return (
        <div>
            <div className="p-5 flex space-x-4 w-full">
                {/* Icon */}
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-indigo-100">
                    <svg className="w-4 h-4 flex-shrink-0 fill-current text-indigo-500" viewBox="0 0 16 16">
                        <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
                    </svg>
                </div>
                {/* Content */}
                <div>
                    {/* Modal header */}
                    <div className="mb-2 flex justify-between">
                        <div className="text-lg font-semibold text-gray-800">{t("Info")}</div>
                        <Button
                            clickHandler={(e) => {
                                e.stopPropagation();
                                setModalOpen(false);
                            }}
                        >
                            <XIcon />
                        </Button>
                    </div>
                    {/* Modal content */}
                    <div className="text-sm mb-4">
                        <div className="space-y-2 min-w-96">
                            <div>
                                {t("Info")}:
                                {
                                    <ul>
                                        {dataToShow && dataToShow.extraData &&
                                            Object.keys(dataToShow.extraData.data).map((value) =>
                                                value === 'createdAt' ? (
                                                    <li key={value}>{formatDateByLanguage(new Date(dataToShow.extraData.data.createdAt), "P")}</li>
                                                ) : (
                                                    <li key={value}>{dataToShow.extraData.data[value as keyof { createdAt: string }]}</li>
                                                ),
                                            )}
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}

                    {dataToShow && dataToShow.extraData && dataToShow.extraData.localStorageName && deleteDataHandler && sendDataHandler &&

                        <div className="flex flex-wrap justify-end">
                            <div>
                                <Button
                                    data-testid="delete-notification-btn"
                                    customClassName="mr-2"
                                    size="sm"
                                    appearance="danger"
                                    clickHandler={(e) => {
                                        e.stopPropagation();
                                        deleteDataHandler(dataToShow);
                                    }}>
                                    {t("abort")}
                                </Button>
                            </div>
                            <Button
                                data-testid="repeat-notification-btn"
                                size="sm"
                                appearance="primary"
                                clickHandler={() => {
                                    sendDataHandler(dataToShow.extraData as any, dataToShow);
                                    setModalOpen(false);
                                }}
                            >
                                {t("try_again")}
                            </Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default AlertModalContainer